import { shipmentApiClient } from '../shipmentApiClient'
import { searchShipmentsEndpoint } from './endpoint'
import type { SearchShipmentsParams, SearchShipmentsRequest, SearchShipmentsResponse } from './type'

export const searchShipments = async (params: SearchShipmentsParams) => {
  const body: SearchShipmentsRequest = {
    delivery_report_uid: params.deliveryReportUid,
    driver_phone: params.driverPhone,
    shipment_uids: params.shipmentUids,
    status: params.status,
  }
  const { data } = await shipmentApiClient.post<SearchShipmentsResponse>(
    searchShipmentsEndpoint,
    body
  )
  return data
}
